import { Component, OnInit, Inject } from '@angular/core';
import { MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';

declare const navigator: any;

@Component({
  selector: 'app-snackbar',
  templateUrl: './snackbar.component.html',
  styleUrls: ['./snackbar.component.css'],
})
export class SnackbarComponent implements OnInit {
  tractIdCopied = false;
  hideCloseButton: boolean = false;

  constructor(@Inject(MAT_SNACK_BAR_DATA) public data: any) {}

  ngOnInit() {
    if(this.data?.closeBtnhide) {
      this.hideCloseButton = true
    }
  }

  get getIcon() {
    switch (this.data.snackType) {
      case 'success':
        return 'done';
      case 'error':
        return 'error';
      case 'warn':
        return 'warning';
      case 'info':
        return 'info';
    }
  }
  copyToClipBoard() {
    const error = `
    ${this.data.message}
    TrackingID: ${this.data.trackingId}
    `;
    navigator.clipboard.writeText(error);
    this.tractIdCopied = true;
  }
  close() {
    this.data.close();
  }
}
